export default "__VITE_ASSET__64329399__"